export const isYearlySubscriptionUtil = (plan) => {
  return /yearly/gi.test(plan)
}
